//console.log('Product Variant Handler file loaded');

(function() {
    try {
        // Define the handler as a global variable first
        window.ProductVariantHandler = class {
            /* ==================================================
            === Start section: Constructor and Initialization ===
            ================================================== */
            constructor() {
                //console.log('=== ProductVariantHandler Constructor Start ===');
                this.gallery = document.querySelector('.product-gallery');
                this.items = this.gallery?.querySelectorAll('.product-gallery__carousel-item');
                this.thumbnails = this.gallery?.querySelectorAll('.product-gallery__thumbnail');
                this.thumbnailList = this.gallery?.querySelector('.product-gallery__thumbnail-list');

                this.productForm = document.querySelector('form[action*="/cart/add"]');
                this.variantSelectors = this.productForm?.querySelectorAll('.product-form__single-selector');
                
                this.productSection = document.querySelector('[data-section-type="product"]');

                // Get product data to find initial variant and set radio buttons to match it
                const productJson = window.globalProductJson;
                this.currentVariant = this.findInitialVariant(productJson);
                //console.log('Initial variant set to:', this.currentVariant);

                // Set radio buttons to match initial variant BEFORE any other initialization
                if (this.currentVariant) {
                    // Set material
                    const materialValue = this.getVariantOptionByContainer(this.currentVariant, 'material-container');
                    const materialInput = this.productForm.querySelector(`.material-container input[value="${materialValue}"]`);
                    if (materialInput) materialInput.checked = true;

                    // Set orientation
                    const orientationValue = this.getVariantOptionByContainer(this.currentVariant, 'orientation-container');
                    const orientationInput = this.productForm.querySelector(`.orientation-container input[value="${orientationValue}"]`);
                    if (orientationInput) orientationInput.checked = true;

                    // Set size
                    const sizeValue = this.getVariantOptionByContainer(this.currentVariant, 'size-container');
                    const sizeInput = this.productForm.querySelector(`.size-container input[value="${sizeValue}"]`);
                    if (sizeInput) sizeInput.checked = true;

                    // Set frame
                    const frameValue = this.getVariantOptionByContainer(this.currentVariant, 'frame-container');
                    const frameInput = this.productForm.querySelector(`.frame-container input[value="${frameValue}"]`);
                    if (frameInput) frameInput.checked = true;
                }

                this.init();

                // Add thumbnail click handling
                if (this.thumbnailList) {
                    this.thumbnailList.addEventListener('click', this.handleThumbnailClick.bind(this));
                }

                // Initialize images immediately
                this.initializeImages();

                // Add touch handling for mobile swipes
                this.touchStartX = 0;
                this.touchEndX = 0;
                this.minSwipeDistance = 50; // Minimum distance for a swipe to register

                // Add touch event listeners to the main gallery/carousel area
                if (this.gallery) {
                    const carouselContainer = this.gallery.querySelector('.product-gallery__carousel');
                    if (carouselContainer) {
                        carouselContainer.addEventListener('touchstart', this.handleTouchStart.bind(this), false);
                        carouselContainer.addEventListener('touchmove', this.handleTouchMove.bind(this), false);
                        carouselContainer.addEventListener('touchend', this.handleTouchEnd.bind(this), false);
                    }
                }
            }

            // Inicializa el product variant handler
            init() {
                //console.log('Initializing ProductVariantHandler');
                
                if (!this.productForm || !this.variantSelectors) {
                    console.error('Required elements not found');
                    return;
                }

                // Add debug log for variant selectors
                /*console.log('Setting up variant selectors:', Array.from(this.variantSelectors).map(selector => ({
                    name: selector.name,
                    value: selector.value,
                    isMaterial: selector.name.endsWith('-1')
                })));*/

                // Listen for changes on variant selectors with specific size handling
                this.variantSelectors.forEach(selector => {
                    selector.addEventListener('change', () => {
                        const isMaterial = selector.closest('.material-container') !== null;
                        const isSize = selector.closest('.size-container') !== null;
                        const isFrame = selector.closest('.frame-container') !== null;
                        const isOrientation = selector.closest('.orientation-container') !== null;
                        
                        /*console.log('Variant selector changed:', {
                            name: selector.name,
                            value: selector.value,
                            isMaterial: isMaterial,
                            isSize: isSize
                        });*/
                        
                        if (isMaterial) {
                            //console.log('Material changed, calling filterAvailableOptions');
                            this.filterAvailableOptions(selector.value, null);
                        }

                        if (isOrientation) {
                            const materialSelector = Array.from(this.variantSelectors)
                                .find(input => input.checked && input.closest('.material-container'));
                            const materialValue = materialSelector ? materialSelector.value : null;
                            const frameSelector = Array.from(this.variantSelectors)
                                .find(input => input.checked && input.closest('.frame-container'));
                            const frameValue = frameSelector ? frameSelector.value : null;
                            this.filterAvailableOptions(materialValue, frameValue);
                        }

                        if (isFrame) {
                            //console.log('Frame changed, calling filterAvailableOptions');
                            const materialSelector = Array.from(this.variantSelectors)
                                .find(input => input.checked && input.closest('.material-container'));
                            const materialValue = materialSelector ? materialSelector.value : null;
                            this.filterAvailableOptions(materialValue, selector.value);
                        }

                        if (isSize) {
                            // Get all size inputs
                            const sizeInputs = this.productForm.querySelectorAll('.size-container input[type="radio"]');
                            
                            // Uncheck all other size inputs
                            sizeInputs.forEach(input => {
                                if (input !== selector) {
                                    input.checked = false;
                                }
                            });
                            
                            // Ensure our target is checked
                            selector.checked = true;
                            
                            this.onVariantChange();
                            
                            return false;
                        }

                        this.onVariantChange();
                    });
                });

                // Initial setup based on current material or orientation
                const materialSelector = Array.from(this.variantSelectors)
                    .find(input => input.checked && input.closest('.material-container'));
                
                if (materialSelector) {
                    //console.log('Initial material found:', materialSelector.value);
                    
                    // If material is Enmarcado, also get the frame selection
                    if (materialSelector.value === 'Enmarcado') {
                        const frameSelector = Array.from(this.variantSelectors)
                            .find(input => input.checked && input.closest('.frame-container'));
                        
                        const frameValue = frameSelector ? frameSelector.value : null;
                        //console.log('Material is Enmarcado, calling filterAvailableOptions with frame:', frameValue);
                        this.filterAvailableOptions(materialSelector.value, frameValue);
                    } else {
                        //console.log('Material is not Enmarcado, calling filterAvailableOptions without frame');
                        this.filterAvailableOptions(materialSelector.value, null);
                    }
                } else {
                    //console.log('No initial material found, filtering by orientation if present');
                    this.filterAvailableOptions(null, null);
                }

                // Initialize URL params if needed
                this.updateURLFromCurrentVariant();

                // Botón de agregar según la variante inicial (#388)
                this.updateAddToCartButton(this.currentVariant);

                // Update custom section visibility on load
                this.updateCanvasSideColorSelectorVisibility(this.currentVariant);

                // Scroll the selected swatches into view
                this.scrollToSelectedSwatches();
            }

            scrollToSelectedSwatches() {
                // Find all checked variant selectors
                const selectedInputs = Array.from(this.variantSelectors).filter(input => input.checked);
                
                selectedInputs.forEach(input => {
                    // Try to find the associated label/swatch that represents this input visually
                    const id = input.id;
                    if (id) {
                        const label = document.querySelector(`label[for="${id}"]`);
                        if (label) {
                            // Find the scrolling container
                            const scrollContainer = label.closest('.block-swatch-list');
                            if (scrollContainer) {
                                // Use a smaller timeout for faster reaction. 50ms is enough for the DOM to update classes
                                setTimeout(() => {
                                    // Recalculate positions
                                    const containerRect = scrollContainer.getBoundingClientRect();
                                    const labelRect = label.getBoundingClientRect();
                                    
                                    // Calculate the true offset left relative to the container's scroll content
                                    const trueOffsetLeft = labelRect.left - containerRect.left + scrollContainer.scrollLeft;
                                    
                                    // Calculate exact scroll position to center the element
                                    const scrollLeft = trueOffsetLeft - (containerRect.width / 2) + (labelRect.width / 2);
                                    
                                    // Apply scroll - removing the 'if (scrollLeft > 0)' condition allows it to scroll 
                                    // backwards to 0 (the beginning of the list) when returning to the first elements.
                                    scrollContainer.scrollTo({
                                        left: Math.max(0, scrollLeft), // Prevent negative scrolling values
                                        behavior: 'smooth'
                                    });
                                }, 50);
                            }
                        }
                    }
                });
            }

            // Inicializa las imágenes
            initializeImages() {
                //console.log('=== Initializing images ===');

                // Get initial variant
                const initialVariant = this.currentVariant;
                //console.log('Initial variant:', initialVariant);

                // Load images for initial variant
                this.handleVariantChange(initialVariant);
            }

            // Encuentra la variante inicial
            findInitialVariant(productJson) {
                //console.log('=== Starting findInitialVariant ===');
                // Method 1: Try URL params first
                const urlParams = new URLSearchParams(window.location.search);
                const variantId = urlParams.get('variant');
                if (variantId) {
                    const urlVariant = productJson.variants.find(v => v.id.toString() === variantId);
                    if (urlVariant) {
                        // Get option values based on containers rather than fixed positions
                        const materialValue = this.getVariantOptionByContainer(urlVariant, 'material-container');
                        if (materialValue) {
                            const materialInput = this.productForm.querySelector(`.material-container input[value="${materialValue}"]`);
                            if (materialInput) materialInput.checked = true;
                        }

                        const orientationValue = this.getVariantOptionByContainer(urlVariant, 'orientation-container');
                        if (orientationValue) {
                            const orientationInput = this.productForm.querySelector(`.orientation-container input[value="${orientationValue}"]`);
                            if (orientationInput) orientationInput.checked = true;
                        }

                        const sizeValue = this.getVariantOptionByContainer(urlVariant, 'size-container');
                        if (sizeValue) {
                            const sizeInput = this.productForm.querySelector(`.size-container input[value="${sizeValue}"]`);
                            if (sizeInput) sizeInput.checked = true;
                        }

                        const frameValue = this.getVariantOptionByContainer(urlVariant, 'frame-container');
                        if (frameValue) {
                            const frameInput = this.productForm.querySelector(`.frame-container input[value="${frameValue}"]`);
                            if (frameInput) frameInput.checked = true;
                        }
                        
                        return urlVariant;
                    }
                }

                // Method 2: Try selected options
                const selectedOptions = Array.from(this.variantSelectors)
                    .filter(input => input.checked)
                    .map(input => input.value);
                
                if (selectedOptions.length > 0) {
                    const selectedVariant = productJson.variants.find(variant => 
                        variant.options.every((option, index) => option === selectedOptions[index])
                    );
                    if (selectedVariant) return selectedVariant;
                }

                // Method 3: Try native select value
                const nativeSelect = document.querySelector('select[name="id"]');
                if (nativeSelect?.value) {
                    const nativeVariant = productJson.variants.find(v => v.id.toString() === nativeSelect.value);
                    if (nativeVariant) return nativeVariant;
                }

                // Method 4: Fallback to first available variant (#388: una variante a $0 no cuenta como disponible)
                const firstAvailable = productJson.variants.find(v => v.available && v.price > 0);
                if (firstAvailable) return firstAvailable;

                // Final fallback: first variant
                return productJson.variants[0];
            }
            /* ================================================
            === End section: Constructor and Initialization ===
            ================================================ */

            /* ====================================
            === Start section: Variant Handling ===
            ==================================== */
            // Método principal para manejar el cambio de variante
            onVariantChange() {
                //console.log('=== Starting variant change process ===');
                
                // Store previous variant before getting new one
                const previousVariant = this.currentVariant;
                
                // Get all selected values
                const selectedOptions = Array.from(this.variantSelectors)
                    .filter(input => input.checked)
                    .map(input => input.value);
                
                //console.log('Selected options:', selectedOptions);

                // Update the displayed selected values for each option
                this.variantSelectors.forEach(selector => {
                    if (selector.checked) {
                        // Find the closest option container
                        const optionContainer = selector.closest('.product-form__option');
                        if (optionContainer) {
                            // Find and update the selected value display
                            const selectedValueDisplay = optionContainer.querySelector('.product-form__selected-value');
                            if (selectedValueDisplay) {
                                selectedValueDisplay.textContent = selector.value;
                            }
                        }
                    }
                });

                // Handle material change first
                const materialOption = this.getSelectedOptionByContainer('material-container');
                
                // Only apply Enmarcado/Sin marco logic if both material and frame containers exist
                const materialContainer = document.querySelector('.material-container');
                const frameContainer = document.querySelector('.frame-container');
                
                if (materialContainer && frameContainer) {
                    if (materialOption !== 'Enmarcado') {
                        this.filterAvailableOptions(materialOption, null);
                        const frameOption = this.getSelectedOptionByContainer('frame-container');
                        if (frameOption !== 'Sin marco') {
                            selectedOptions[this.getContainerIndex('frame-container')] = 'Sin marco';
                        }
                    } else {
                        // When material is Enmarcado, pass the selected frame value
                        const frameOption = this.getSelectedOptionByContainer('frame-container');
                        this.filterAvailableOptions(materialOption, frameOption);
                    }
                }

                // Get the matching variant AFTER potentially updating the frame selection
                const productJson = window.globalProductJson;
                //console.log('Looking for variant with options:', selectedOptions);
                
                const matchingVariant = productJson.variants.find(variant => {
                    const matches = variant.options.every((option, index) => option === selectedOptions[index]);
                    //console.log('Checking variant:', variant.title, 'Matches:', matches);
                    return matches;
                });

                if (matchingVariant) {
                    //console.log('Found matching variant:', matchingVariant);

                    // Update URL using the dedicated method
                    this.updateURL(matchingVariant.id);

                    // Update price
                    this.updatePrice(matchingVariant);

                    // Update add-to-cart button (#388)
                    this.updateAddToCartButton(matchingVariant);

                    // Update SKU
                    this.updateSku(matchingVariant, previousVariant);

                    // Update Title
                    this.updateTitle(matchingVariant);

                    // Update custom section visibility
                    this.updateCanvasSideColorSelectorVisibility(matchingVariant);

                    // Update native selector and trigger events
                    const nativeSelect = document.querySelector('select[name="id"]');
                    if (nativeSelect && nativeSelect.value !== matchingVariant.id.toString()) {
                        nativeSelect.value = matchingVariant.id;
                        
                        // Trigger both native change and theme's variant change events
                        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                        
                        if (this.productSection) {
                            this.productSection.dispatchEvent(new CustomEvent('variant:changed', {
                                detail: {
                                    variant: matchingVariant,
                                    previousVariant: this.currentVariant
                                },
                                bubbles: true
                            }));
                        }
                    }

                    // TiB (Teeinblue) Custom Check:
                    // If we're on a personalized product (indicated by .tee-form-wrapper) and the Orientation or Aspect Ratio changes,
                    // we simulate a click on the "clear photo" button. This forces the user to re-upload and re-crop 
                    // their image for the new dimensions, preventing it from just stretching.
                    const currentOrientation = this.getVariantOptionByContainer(this.currentVariant, 'orientation-container');
                    const newOrientation = this.getVariantOptionByContainer(matchingVariant, 'orientation-container');
                    const orientationChanged = currentOrientation && newOrientation && currentOrientation !== newOrientation;

                    // Check if proportion changed
                    let proportionChanged = false;
                    const sizeContainerElement = document.querySelector('.size-container');
                    if (sizeContainerElement && this.currentVariant) {
                        const currentSizeInput = sizeContainerElement.querySelector('input:checked');
                        const prevSizeValue = this.getVariantOptionByContainer(this.currentVariant, 'size-container');
                        if (currentSizeInput && prevSizeValue) {
                            const prevSizeInput = sizeContainerElement.querySelector(`input[value="${CSS.escape(prevSizeValue)}"]`);
                            if (prevSizeInput) {
                                const currentProportion = currentSizeInput.getAttribute('data-proporcion');
                                const prevProportion = prevSizeInput.getAttribute('data-proporcion');
                                if (currentProportion !== null && prevProportion !== null && currentProportion !== prevProportion) {
                                    proportionChanged = true;
                                }
                            }
                        }
                    }

                    if ((orientationChanged || proportionChanged) && document.querySelector('.tee-form-wrapper')) {
                        // Use a small delay before clearing to allow TiB framework (Vue) to settle its DOM
                        setTimeout(() => {
                            const clearBtns = document.querySelectorAll('.tee-photo-clear');
                            clearBtns.forEach(btn => btn.click());
                        }, 300);
                    }

                    // Only update images if material or frame changed (not for size changes)
                    const currentMaterial = this.getVariantOptionByContainer(this.currentVariant, 'material-container');
                    const newMaterial = this.getVariantOptionByContainer(matchingVariant, 'material-container');
                    const currentFrame = this.getVariantOptionByContainer(this.currentVariant, 'frame-container');
                    const newFrame = this.getVariantOptionByContainer(matchingVariant, 'frame-container');

                    const materialChanged = currentMaterial !== newMaterial;
                    const frameChanged = currentFrame !== newFrame;
                    
                    if (materialChanged) {
                        this.updateDynamicMaterialsExplainer(newMaterial);
                    }

                    if (materialChanged || frameChanged) {
                        if (matchingVariant.featured_image || matchingVariant.featured_media) {
                            this.handleVariantChange(matchingVariant);
                        }
                    }

                    // Store current variant
                    this.currentVariant = matchingVariant;
                } else {
                    console.warn('No matching variant found for options:', selectedOptions);
                }
                
                // Desplazar automáticamente para centrar el selector (swatch) recién seleccionado
                this.scrollToSelectedSwatches();
                
                //console.log('=== Variant change process completed ===');
            }

            // Este método maneja el cambio de variante cuando se cambia de material o marco (no de tamaño)
            handleVariantChange(variant) {
                // This method updates the gallery images when a variant changes
                // It handles both material changes (which affect supporting images) and frame changes
                //console.log('Starting variant change handling for:', variant);
                if (!variant) {
                    console.warn('No variant provided to handleVariantChange');
                    return;
                }

                // Check if this is a material change that requires updating supporting images
                const previousMaterial = this.getVariantOptionByContainer(this.currentVariant, 'material-container');
                const newMaterial = this.getVariantOptionByContainer(variant, 'material-container');
                //console.log('Previous material:', previousMaterial, 'New material:', newMaterial);
                const isMaterialChange = previousMaterial !== newMaterial;
                //console.log('Is material change:', isMaterialChange);

                this.currentVariant = variant;
                //console.log('Current variant:', this.currentVariant);

                // Find and validate the variant's primary image
                const variantImage = this.findVariantImage(variant);
                //console.log('Found variant image:', variantImage);

                if (!variantImage) {
                    console.warn('No matching image found for variant:', variant.id);
                    return;
                }

                // Update supporting images visibility when material changes
                if (isMaterialChange) {
                    this.stopAllVideos();
                    
                    //console.log('Material changed, updating supporting images');
                    
                    const thumbnails = document.querySelectorAll('.product-gallery__thumbnail');
                    const carouselItems = Array.from(this.items);
                    
                    thumbnails.forEach(thumbnail => {
                        const mediaId = thumbnail.dataset.mediaId;
                        
                        // Preserve size guide and main variant image visibility
                        if (thumbnail.querySelector('img[alt="size guide"]') || 
                            mediaId === variantImage.id.toString()) {
                            return;
                        }

                        // Show/hide supporting images based on material relevance
                        const isRelevantForMaterial = this.isImageRelevantForMaterial(thumbnail, newMaterial);
                        /*console.log('Checking thumbnail:', {
                            mediaId: mediaId,
                            isRelevant: isRelevantForMaterial
                        });*/

                        // Update thumbnail classes
                        if (isRelevantForMaterial) {
                            thumbnail.classList.remove('is-filtered');
                            // Find and update corresponding carousel item
                            const carouselItem = carouselItems.find(item => item.dataset.mediaId === mediaId);
                            if (carouselItem) carouselItem.classList.remove('is-filtered');
                        } else {
                            thumbnail.classList.add('is-filtered');
                            // Find and update corresponding carousel item
                            const carouselItem = carouselItems.find(item => item.dataset.mediaId === mediaId);
                            if (carouselItem) carouselItem.classList.add('is-filtered');
                        }
                    });
                }

                // Update main image visibility and handle special cases (size guide, videos)
                this.items.forEach(item => {
                    const isSizeGuide = item.querySelector('img[alt="size guide"]');
                    const isVariantImage = item.dataset.mediaId === variantImage.id.toString();

                    if (isSizeGuide) {
                        // Always remove is-selected from size guide when changing variants
                        item.classList.remove('is-selected');
                    } else if (isVariantImage) {
                        item.classList.remove('is-filtered');
                        item.classList.add('is-selected');
                        // Stop videos when switching to a different featured image
                        this.stopAllVideos();
                    } else {
                        // Only add is-filtered if it's not a supporting image that should be visible
                        const shouldBeVisible = this.isImageRelevantForMaterial(item, newMaterial);
                        if (!shouldBeVisible) item.classList.add('is-filtered');
                        item.classList.remove('is-selected');
                    }
                });

                // Sync thumbnail navigation state with main gallery
                if (this.thumbnailList) {
                    const thumbnails = this.thumbnailList.querySelectorAll('.product-gallery__thumbnail');
                    thumbnails.forEach(thumbnail => {
                        const isSizeGuide = thumbnail.querySelector('img[alt="size guide"]');
                        const isVariantImage = thumbnail.dataset.mediaId === variantImage.id.toString();

                        if (isSizeGuide) {
                            // Always remove is-nav-selected from size guide when changing variants
                            thumbnail.classList.remove('is-nav-selected');
                            // Don't modify is-filtered state for size guide
                        } else if (isVariantImage) {
                            thumbnail.classList.remove('is-filtered');
                            thumbnail.classList.add('is-nav-selected');
                        } else {
                            // Only add is-filtered if it's not a supporting image that should be visible
                            const shouldBeVisible = this.isImageRelevantForMaterial(thumbnail, newMaterial);
                            if (!shouldBeVisible) {
                                thumbnail.classList.add('is-filtered');
                            }
                            thumbnail.classList.remove('is-nav-selected');
                        }
                    });
                }

                // Reinitialize zoom functionality after image updates
                // This is necessary because the zoom handler doesn't detect variant changes
                this.reinitializeZoom();
            }

            // Encuentra la imagen de la variante seleccionada
            findVariantImage(variant) {
                // Get the product data from the ProductJson element
                const productJson = window.globalProductJson;
                if (!productJson?.media) {
                    console.error('Product media data not found');
                    return null;
                }

                // Find the featured image that matches this variant
                const variantImageId = variant.featured_media?.id || variant.featured_image?.id;
                if (!variantImageId) {
                    console.warn('No featured image ID in variant:', variant);
                    return null;
                }

                //console.log('Looking for image with ID:', variantImageId);
                //console.log('Available media:', productJson.media);

                return productJson.media.find(media => media.id === variantImageId);
            }

            // Actualiza la sección dinámica de explicación de materiales
            updateDynamicMaterialsExplainer(newMaterial) {
                const explainerSection = document.getElementById('product-materials-explainer-dynamic');
                if (!explainerSection) return;

                const items = explainerSection.querySelectorAll('.dynamic-materials-item');
                items.forEach(item => {
                    const targetMaterial = item.dataset.materialTarget;
                    if (targetMaterial && newMaterial && targetMaterial.toLowerCase() === newMaterial.toLowerCase()) {
                        item.classList.remove('is-hidden');
                    } else {
                        item.classList.add('is-hidden');
                    }
                });
            }

            // Filtra las opciones disponibles para el material seleccionado (Tamaños y Marco)
            filterAvailableOptions(selectedMaterial, selectedFrame) {
                // This method manages the complex interaction between material, size, and frame options
                // It ensures that only valid combinations are selectable based on the current material choice
                //console.log('=== Starting size filtering process ===');
                //console.log('Selected material:', selectedMaterial);

                const productJson = window.globalProductJson;
                
                // Locate option containers in the DOM
                const materialContainer = document.querySelector('.product-form__option.variant-container.material-container');
                const sizeContainer = document.querySelector('.product-form__option.variant-container.size-container');
                const frameContainer = document.querySelector('.product-form__option.variant-container.frame-container');


                // Debug frame swatches before any changes
                if (frameContainer) {
                    const frameSwatches = frameContainer.querySelectorAll('.block-swatch');
                    /*console.log('Frame swatches before changes:', Array.from(frameSwatches).map(swatch => ({
                        value: swatch.querySelector('input')?.value,
                        style: swatch.getAttribute('style'),
                        classes: swatch.className
                    })));*/
                }

                // Handle frame visibility and options
                if (frameContainer) {
                    // Get all frame swatches and remove any inline styles first
                    // Reset frame swatch styles
                    const frameSwatches = frameContainer.querySelectorAll('.block-swatch');
                    frameSwatches.forEach(swatch => {
                        swatch.removeAttribute('style');
                    });

                    // Special handling for "Sin marco" (No frame) option
                    const sinMarcoSwatch = frameContainer.querySelector('.block-swatch:has(input[value="Sin marco"])');
                    if (sinMarcoSwatch) {
                        sinMarcoSwatch.classList.add('block-swatch--disabled');
                        sinMarcoSwatch.classList.remove('is-selected');
                        const sinMarcoInput = sinMarcoSwatch.querySelector('input');
                        if (sinMarcoInput) {
                            sinMarcoInput.disabled = true;
                            sinMarcoInput.checked = false;
                        }
                    }

                    // Only apply material-based visibility if material container exists
                    if (materialContainer) {
                        if (selectedMaterial === 'Enmarcado') {
                            frameContainer.classList.remove('frame-container__hide');
                            frameContainer.classList.add('frame-container__show');
                            
                            // Only auto-select first frame if no frame is currently selected
                            // or if "Sin marco" is currently selected
                            const currentSelectedFrame = frameContainer.querySelector('.block-swatch__radio:checked');
                            if (!currentSelectedFrame || currentSelectedFrame.value === 'Sin marco') {
                                const firstAvailableFrame = frameContainer.querySelector('.block-swatch:not(.block-swatch--disabled) input[type="radio"]:not([value="Sin marco"])');
                                if (firstAvailableFrame) {
                                    firstAvailableFrame.checked = true;
                                    firstAvailableFrame.dispatchEvent(new Event('change', { bubbles: true }));
                                    firstAvailableFrame.closest('.block-swatch').classList.add('is-selected');
                                }
                            }
                        } else {
                            frameContainer.classList.add('frame-container__hide');
                            frameContainer.classList.remove('frame-container__show');
                            // When not Enmarcado, ensure Sin marco is selected and has is-selected class
                            if (sinMarcoSwatch) {
                                const sinMarcoInput = sinMarcoSwatch.querySelector('input');
                                if (sinMarcoInput) {
                                    sinMarcoInput.checked = true;
                                    sinMarcoSwatch.classList.add('is-selected');
                                }
                                // Remove is-selected from all other frame options
                                frameContainer.querySelectorAll('.block-swatch:not(:has(input[value="Sin marco"]))').forEach(swatch => {
                                    swatch.classList.remove('is-selected');
                                });
                            }
                        }
                    } else if (!materialContainer && frameContainer) {
                        // If no material container exists but frame container does, always show frame container
                        // (Assuming that if there's no material container, but there is a frame container, it's because the product is "Enmarcado" by default)
                        frameContainer.classList.remove('frame-container__hide');
                        frameContainer.classList.add('frame-container__show');
                    }
                }

                // Handle size filtering
                if (sizeContainer) {
                    //console.log('=== Starting size container options filtering ===');
                    const sizeOptions = sizeContainer.querySelectorAll('.block-swatch');
                    const selectedOrientation = this.getSelectedOptionByContainer('orientation-container');
                    
                    // Filter variants based on container classes and selected options
                    const availableVariants = productJson.variants.filter(variant => {
                        const variantMaterial = this.getVariantOptionByContainer(variant, 'material-container');
                        const variantFrame = this.getVariantOptionByContainer(variant, 'frame-container');
                        const variantOrientation = this.getVariantOptionByContainer(variant, 'orientation-container');
                        
                        // Match material, frame, and orientation (if selected)
                        const materialMatches = !selectedMaterial || variantMaterial === selectedMaterial;
                        const frameMatches = !selectedFrame || variantFrame === selectedFrame;
                        const orientationMatches = !selectedOrientation || variantOrientation === selectedOrientation;
                        
                        // #388: una variante a $0 se esconde igual que una agotada
                        return materialMatches && frameMatches && orientationMatches && variant.available && variant.price > 0;
                    });

                    // Get available sizes using container identification
                    const availableSizes = [...new Set(availableVariants.map(v => 
                        this.getVariantOptionByContainer(v, 'size-container')
                    ))];

                    sizeOptions.forEach(sizeOption => {
                        const input = sizeOption.querySelector('.block-swatch__radio');
                        if (availableSizes.includes(input.value)) {
                            sizeOption.classList.remove('block-swatch--disabled');
                            input.disabled = false;
                            sizeOption.style.display = '';
                        } else {
                            sizeOption.classList.add('block-swatch--disabled');
                            input.disabled = true;
                            sizeOption.style.display = 'none';

                            // Only auto-select first available size if the current selection becomes unavailable
                            if (input.checked && availableSizes.length > 0) {
                                const firstAvailableInput = sizeContainer.querySelector(
                                    `.block-swatch__radio[value="${availableSizes[0]}"]`
                                );
                                if (firstAvailableInput) {
                                    firstAvailableInput.checked = true;
                                    firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
                                }
                            }
                        }
                    });

                    // Hide empty proportion wrappers for grouped aspect ratios
                    const proportionWrappers = sizeContainer.querySelectorAll('.proportion-wrapper');
                    let visibleWrappersCount = 0;

                    proportionWrappers.forEach(wrapper => {
                        const hasVisibleSwatches = Array.from(wrapper.querySelectorAll('.block-swatch')).some(
                            swatch => swatch.style.display !== 'none'
                        );
                        if (hasVisibleSwatches) {
                            wrapper.style.display = 'block';
                            visibleWrappersCount++;
                        } else {
                            wrapper.style.display = 'none';
                        }
                    });

                    // Hide labels if only one proportion group is visible
                    proportionWrappers.forEach(wrapper => {
                        const label = wrapper.querySelector('.proportion-label');
                        if (label) {
                            label.style.display = visibleWrappersCount > 1 ? 'block' : 'none';
                        }
                    });
                }

                // Debug frame swatches after changes
                if (frameContainer && selectedMaterial === 'Enmarcado') {
                    const frameSwatches = frameContainer.querySelectorAll('.block-swatch');
                    /*console.log('Frame swatches after changes:', Array.from(frameSwatches).map(swatch => ({
                        value: swatch.querySelector('input')?.value,
                        style: swatch.getAttribute('style'),
                        classes: swatch.className
                    })));*/
                }
            }

            // Actualiza el precio correspondiente a la variante seleccionada
            updatePrice(variant) {
                // Find all price elements by class (and fallback to old IDs for compatibility)
                const selectedPriceElements = document.querySelectorAll('.js-selected-price, #selectedPrice');
                const normalPriceElements = document.querySelectorAll('.js-precio-normal, #precioNormal');
                const discountElements = document.querySelectorAll('.js-descuento-aplicado, #descuentoAplicado');
                const discountAmountElements = document.querySelectorAll('.js-descuento-monto, #descuentoMonto');
                const listPriceContainers = document.querySelectorAll('.priceProducts__list-price-container');
                const savingsContainers = document.querySelectorAll('.js-savings-container, #savingsContainer');

                if (selectedPriceElements.length > 0 || normalPriceElements.length > 0) {
                    // Format prices
                    const formattedPrice = this.formatMoney(variant.price).replace(/\s+/g, '');
                    const formattedComparePrice = variant.compare_at_price ? this.formatMoney(variant.compare_at_price).replace(/\s+/g, '') : null;

                    // Update current price
                    selectedPriceElements.forEach(el => el.textContent = formattedPrice);

                    // Update compare at price and discount
                    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                        normalPriceElements.forEach(el => el.textContent = formattedComparePrice);
                        listPriceContainers.forEach(el => el.style.display = '');
                        
                        // Calculate and update discount percentage and amount
                        const discountPercentage = Math.round((1 - variant.price / variant.compare_at_price) * 100);
                        discountElements.forEach(el => el.textContent = `${discountPercentage}%`);
                        
                        const discountAmount = variant.compare_at_price - variant.price;
                        const formattedDiscountAmount = this.formatMoney(discountAmount).replace(/\s+/g, '');
                        discountAmountElements.forEach(el => el.textContent = formattedDiscountAmount);
                        
                        savingsContainers.forEach(el => el.style.display = '');
                    } else {
                        listPriceContainers.forEach(el => el.style.display = 'none');
                        savingsContainers.forEach(el => el.style.display = 'none');
                    }
                }
            }

            // Actualiza el botón de agregar según la variante (#388). Una variante a $0 es un error
            // de precio en origen y se trata como no disponible, igual que una agotada. El Liquid pinta
            // el estado inicial; aquí se actualiza en ambos sentidos. En el caso normal (variante con
            // precio y botón sin bloquear) no toca nada, para no pisar lo que apps como TiB le hagan
            // al botón. Sólo actúa sobre el botón con data-action (el de "Agotado" que pinta el Liquid
            // no lo lleva y se queda como está). La barra sticky de #236 copia el estado solita
            // (MutationObserver). La guarda final, que revisa el id que el form va a mandar, vive en
            // theme.js.
            updateAddToCartButton(variant) {
                const button = this.productForm?.querySelector('.product-form__add-button[data-action="add-to-cart"]');
                if (!button || !variant) return;

                const purchasable = variant.available && variant.price > 0;
                const blocked = button.hasAttribute('data-variant-unavailable');

                if (purchasable && !blocked) return;

                if (purchasable) {
                    button.removeAttribute('data-variant-unavailable');
                    button.disabled = false;
                    button.classList.remove('button--disabled');
                    button.classList.add('button--primary');
                    if (this.addToCartOriginalHtml) {
                        button.innerHTML = this.addToCartOriginalHtml;
                    } else {
                        button.textContent = window.languages.productFormAddToCart;
                    }
                    return;
                }

                if (!blocked) {
                    this.addToCartOriginalHtml = button.innerHTML;
                }

                button.setAttribute('data-variant-unavailable', '');
                button.disabled = true;
                button.classList.remove('button--primary');
                button.classList.add('button--disabled');
                button.textContent = variant.available ? window.languages.productFormUnavailable : window.languages.productFormSoldOut;
            }

            // Este método actualiza el URL con el ID de la variante actual cada que se cambie la variante.
            // Se ejecuta DIFERIDO y con debounce (#331): history.replaceState está parcheado por terceros
            // (pixel de Meta y gtag disparan un PageView en cada cambio de URL) y costaba ~150-200 ms de
            // main thread dentro de la interacción — era la mayor parte del INP del cambio de variante.
            // Sacarlo del handler síncrono deja que el tap pinte primero; el debounce colapsa taps seguidos
            // (y el doble onVariantChange del cambio de material) en una sola actualización.
            updateURL(variantId) {
                if (!variantId) return;

                clearTimeout(this._updateURLTimer);
                this._updateURLTimer = setTimeout(() => {
                    try {
                        const newUrl = new URL(window.location.href);
                        const currentVariantId = newUrl.searchParams.get('variant');

                        if (currentVariantId !== variantId.toString()) {
                            newUrl.searchParams.set('variant', variantId);
                            window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
                        }
                    } catch (error) {
                        console.error('Error updating URL:', error);
                    }
                }, 400);
            }

            // Este método sirve en la inicialización para actualizar la URL con el ID de la variante actual
            updateURLFromCurrentVariant() {
                const urlParams = new URLSearchParams(window.location.search);
                const currentVariantId = urlParams.get('variant');
                
                if (!currentVariantId && this.currentVariant) {
                    this.updateURL(this.currentVariant.id);
                }
            }

            // Add this new method
            updateSku(newVariant, previousVariant) {
                const productSku = document.querySelector('.product-meta__sku');
                if (!productSku) return;

                const productSkuNumber = productSku.querySelector('.product-meta__sku-number');
                if (!productSkuNumber) return;

                // Hide SKU section if variant doesn't exist or has no SKU
                if (!newVariant || !newVariant.sku) {
                    productSku.style.display = 'none';
                    return;
                }

                // Skip update if SKU hasn't changed
                if (previousVariant && previousVariant.sku === newVariant.sku) {
                    return;
                }

                // Update SKU and ensure it's visible
                productSkuNumber.textContent = newVariant.sku;
                productSku.style.display = '';
            }

            updateTitle(newVariant) {
                const titleElement = document.querySelector('.product-meta__title');
                if (!titleElement || !newVariant) return;

                let defaultTitle = titleElement.getAttribute('data-default-title');
                if (!defaultTitle) {
                    // Try to get from a tag if available
                    const a = titleElement.querySelector('a');
                    if (a && a.hasAttribute('data-default-title')) {
                        defaultTitle = a.getAttribute('data-default-title');
                    }
                }
                
                if (!defaultTitle) return;

                let displayTitle = defaultTitle;
                const titlesJsonEl = document.getElementById('VariantDisplayTitles-product-template');
                if (titlesJsonEl) {
                    try {
                        const titlesJson = JSON.parse(titlesJsonEl.textContent);
                        if (titlesJson && titlesJson[newVariant.id]) {
                            displayTitle = titlesJson[newVariant.id];
                        }
                    } catch (e) {
                        console.error('Error parsing VariantDisplayTitles JSON:', e);
                    }
                }

                if (titleElement.tagName === 'H1') {
                    titleElement.textContent = displayTitle;
                } else {
                    const a = titleElement.querySelector('a');
                    if (a) a.textContent = displayTitle;
                }
            }

            updateCanvasSideColorSelectorVisibility(variant) {
                /*  Este método es para actualizar la visibilidad del selector de color del en el producto personalizado.
                    (Cuando es canvas personalizado)
                */
                const customSection = document.getElementById('cart_attr');
                if (!customSection) {
                    return;
                }
            
                // Get the inputs within the section
                const perfilSelect = customSection.querySelector('#perfil');
                const colorInput = customSection.querySelector('#color');
            
                const productJson = window.globalProductJson;
                const hasCustomTag = productJson.tags.includes('03-custom');
                const hasExcludeTag = productJson.tags.includes('diseños-especiales');
            
                const skuMatches = variant && variant.sku && variant.sku.includes('_can-');
            
                const shouldShow = !hasExcludeTag && hasCustomTag && skuMatches;
            
                if (shouldShow) {
                    customSection.style.display = 'block';

                    if (perfilSelect) {
                        perfilSelect.disabled = false;
            
                        // Check if the color input should also be visible and enabled
                        const shouldShowColor = perfilSelect.value === 'Color';
            
                        if (colorInput) {
                            colorInput.style.display = shouldShowColor ? 'inline-block' : 'none';
                            colorInput.disabled = !shouldShowColor;
                            colorInput.required = shouldShowColor;
                        }
                    }
                } else {
                    customSection.style.display = 'none';
                    if (perfilSelect) perfilSelect.disabled = true;
                    if (colorInput) {
                        colorInput.disabled = true;
                        colorInput.style.display = 'none';
                    }
                }
            }
            /* ==================================
            === End section: Variant Handling ===
            ================================== */

            /* ==============================================
            === Start section: Gallery and Image Handling ===
            ============================================== */
            // Este método dispara lo que debe de ocurrir cuando se selecciona una imagen de la galería
            handleThumbnailClick(event) {
                //console.log('handleThumbnailClick triggered');
                // Prevent default anchor tag behavior so that the thumbnail doesn't open the image in a new tab
                event.preventDefault();
                
                // Find the closest anchor tag (thumbnail)
                const thumbnail = event.target.closest('a.product-gallery__thumbnail');
                if (!thumbnail) return;

                const mediaId = thumbnail.dataset.mediaId;
                if (!mediaId) return;
                //console.log('Media ID:', mediaId);

                // Stop videos when switching images
                this.stopAllVideos();

                // Update thumbnails selection state
                this.thumbnailList.querySelectorAll('.product-gallery__thumbnail').forEach(thumb => {
                    if (thumb.dataset.mediaId === mediaId) {
                        thumb.classList.add('is-nav-selected');
                    } else {
                        thumb.classList.remove('is-nav-selected');
                    }
                });

                // Center the selected thumbnail
                this.centerSelectedThumbnail(thumbnail);

                // Get the currently selected item and the new item
                const currentItem = this.gallery.querySelector('.product-gallery__carousel-item.is-selected');
                const newItem = this.gallery.querySelector(`.product-gallery__carousel-item[data-media-id="${mediaId}"]`);

                if (!newItem) return;

                // Simple direct switching of images
                if (currentItem) {
                    currentItem.classList.remove('is-selected');
                    currentItem.classList.add('is-filtered');
                }

                newItem.classList.remove('is-filtered');
                newItem.classList.add('is-selected');

                // Reset touch variables after changing the image (To retain the functionality of the swipe gesture and quick-tap for fullscreen view)
                this.touchStartX = 0;
                this.touchEndX = 0;
                this.touchStartTime = 0;

                // Auto-play video if the new item contains a video
                const video = newItem.querySelector('video');
                if (video) {
                    video.muted = true;
                    video.play().catch(error => {
                        console.warn('Auto-play failed:', error);
                        // Some browsers require user interaction before playing
                    });
                }
            }

            // Este método centra la imagen seleccionada en la galería (sea vertical u horizontal)
            centerSelectedThumbnail(selectedThumbnail) {
                if (!this.thumbnailList || !selectedThumbnail) return;

                const thumbnailContainer = this.thumbnailList;
                const isVertical = window.innerWidth >= 1000; // 1000px is the desktop breakpoint
                
                // Set appropriate overflow based on layout
                if (isVertical) {
                    thumbnailContainer.style.overflowY = 'auto';
                    thumbnailContainer.style.overflowX = 'hidden';
                } else {
                    thumbnailContainer.style.overflowX = 'auto';
                    thumbnailContainer.style.overflowY = 'hidden';
                    thumbnailContainer.style.whiteSpace = 'nowrap'; // Ensure horizontal layout
                }

                /*console.log('Centering thumbnail:', {
                    isVertical: isVertical,
                    windowWidth: window.innerWidth,
                    selectedThumbnail: selectedThumbnail.dataset.mediaId
                });*/

                // Get dimensions
                const containerRect = thumbnailContainer.getBoundingClientRect();
                const thumbnailRect = selectedThumbnail.getBoundingClientRect();
                
                if (isVertical) {
                    // Vertical scrolling (desktop)
                    const containerHeight = containerRect.height;
                    const targetPosition = thumbnailRect.top + thumbnailContainer.scrollTop - containerRect.top;
                    const centerPosition = targetPosition - (containerHeight / 2) + (thumbnailRect.height / 2);
                    
                    // Calculate max scroll to prevent empty space at the bottom
                    const maxScroll = thumbnailContainer.scrollHeight - containerHeight;
                    const finalScroll = Math.max(0, Math.min(centerPosition, maxScroll));
                    
                    thumbnailContainer.scrollTo({
                        top: finalScroll,
                        behavior: 'smooth'
                    });
                } else {
                    // Horizontal scrolling (mobile)
                    //console.log('Attempting mobile scroll...');
                    
                    // First, verify the container is scrollable
                    /*console.log('Container scroll properties:', {
                        scrollable: thumbnailContainer.style.overflowX,
                        hasScroll: thumbnailContainer.scrollWidth > thumbnailContainer.clientWidth,
                        scrollWidth: thumbnailContainer.scrollWidth,
                        clientWidth: thumbnailContainer.clientWidth
                    });*/

                    const containerWidth = containerRect.width;
                    const targetPosition = thumbnailRect.left - containerRect.left + thumbnailContainer.scrollLeft;
                    const centerOffset = (containerWidth - thumbnailRect.width) / 2;
                    const centerPosition = targetPosition - centerOffset;
                    
                    // Calculate max scroll to prevent empty space at the right
                    const maxScroll = thumbnailContainer.scrollWidth - containerWidth;
                    const finalScroll = Math.max(0, Math.min(centerPosition, maxScroll));

                    // Log the actual scroll attempt
                    //console.log('Attempting to scroll to:', finalScroll);
                    
                    try {
                        thumbnailContainer.scrollTo({
                            left: finalScroll,
                            behavior: 'smooth'
                        });
                        //console.log('Scroll command executed');
                        
                        // Check if scroll position changed
                        setTimeout(() => {
                            //console.log('Scroll position after attempt:', thumbnailContainer.scrollLeft);
                        }, 100);
                    } catch (error) {
                        console.error('Error during scroll:', error);
                    }
                }
            }

            // Encuentra las imágenes relevantes para el material actual
            isImageRelevantForMaterial(item, currentMaterial) {
                // Get the group name and value from the item's data attributes
                const groupName = item.dataset.groupName;
                const groupValue = item.dataset.groupValue;

                // If the item doesn't have group attributes, consider it always relevant
                if (!groupName || !groupValue) {
                    return true;
                }

                // If currentMaterial is null (e.g. product has no material selector),
                // we assume its relevance hasn't changed from what Liquid rendered
                if (!currentMaterial) {
                    return !item.classList.contains('is-filtered');
                }

                // Check if this image is tagged for the current material
                // Using toLowerCase() for case-insensitive comparison and checking both "material" and "material base"
                const isRelevant = (groupName.toLowerCase() === 'material' || groupName.toLowerCase() === 'material base' || groupName.toLowerCase() === 'materiales') && 
                                  groupValue.toLowerCase() === currentMaterial.toLowerCase();
                
                return isRelevant;
            }

            // Reinicializa zoom al cambiar la variante
            reinitializeZoom() {
                /* Aunque la funcionalidad de zoom es manejada por el archivo extra_js_product_zoom_handler.js,
                esa función no sabe detectar cuando hay un cambio de variable y por lo tanto reiniciar el zoom.
                Es por eso que se debe reiniciar el zoom aquí. */
                if (window.productZoom) {
                    window.productZoom.reinitialize();
                }
            }

            // Detiene todos los videos en la galería
            stopAllVideos() {
                const videoElements = this.gallery.querySelectorAll('video, iframe');
                if (!videoElements?.length) return; // Early return if no videos found
            
                videoElements.forEach(video => {
                    if (video.tagName === 'VIDEO') {
                        // Handle native video elements
                        video.pause();
                        video.currentTime = 0;
                    } else if (video.tagName === 'IFRAME') {
                        // Handle iframe videos (like YouTube)
                        try {
                            video.src = video.src;
                        } catch (error) {
                            console.warn('Error stopping iframe video:', error);
                        }
                    }
                });
            }
            /* ============================================
            === End section: Gallery and Image Handling ===
            ============================================ */

            /* ========================================
            === Start section: Touch Event Handlers ===
            ======================================== */
            // Estos métodos manejan el deslizamiento de las imágenes en dispositivos móviles
            handleTouchStart(event) {
                this.touchStartX = event.touches[0].clientX;
                this.touchStartTime = Date.now();
            }

            handleTouchMove(event) {
                this.touchEndX = event.touches[0].clientX;
            }

            handleTouchEnd() {
                //console.log('handleTouchEnd triggered');
                
                // If touchEndX is 0, it means there was no move event, so use touchStartX
                if (this.touchEndX === 0) {
                    this.touchEndX = this.touchStartX;
                }
                
                const swipeDistance = this.touchEndX - this.touchStartX;
                const swipeTime = Date.now() - this.touchStartTime;
                
                /*console.log('Touch metrics:', {
                    startX: this.touchStartX,
                    endX: this.touchEndX,
                    distance: swipeDistance,
                    time: swipeTime
                });*/
                
                // If it's a quick tap (less than 300ms), handle it as a click
                if (Math.abs(swipeDistance) < 10 && swipeTime < 300) {
                    //console.log('Quick tap detected');
                    // Handle tap - open fullscreen view
                    const currentItem = this.gallery.querySelector('.product-gallery__carousel-item.is-selected');
                    if (currentItem) {
                        //console.log('Current item found');
                        const image = currentItem.querySelector('.product-gallery__image');
                        if (image && image.dataset.zoom) {
                            //console.log('Image found and zoom data available');
                            this.openFullscreenView(image.dataset.zoom);
                        }
                    }
                    return;
                }
                
                // Only process if it's a significant swipe
                if (Math.abs(swipeDistance) > this.minSwipeDistance) {
                    const currentItem = this.gallery.querySelector('.product-gallery__carousel-item.is-selected');
                    if (!currentItem) return;

                    const currentMediaId = currentItem.dataset.mediaId;
                    const visibleThumbnails = Array.from(this.thumbnailList.querySelectorAll('.product-gallery__thumbnail:not(.is-filtered)'));
                    const currentIndex = visibleThumbnails.findIndex(thumb => thumb.dataset.mediaId === currentMediaId);

                    if (currentIndex === -1) return;

                    let nextIndex;
                    if (swipeDistance > 0) {
                        // Swipe right - show previous image
                        nextIndex = currentIndex - 1;
                        if (nextIndex < 0) nextIndex = visibleThumbnails.length - 1;
                    } else {
                        // Swipe left - show next image
                        nextIndex = currentIndex + 1;
                        if (nextIndex >= visibleThumbnails.length) nextIndex = 0;
                    }

                    // Simulate click on the next thumbnail
                    const nextThumbnail = visibleThumbnails[nextIndex];
                    if (nextThumbnail) {
                        this.handleThumbnailClick({ 
                            preventDefault: () => {},
                            target: nextThumbnail
                        });
                    }
                }

                // Reset touch coordinates and time
                this.touchStartX = 0;
                this.touchEndX = 0;
                this.touchStartTime = 0;
            }

            openFullscreenView(imageUrl) {
                //console.log('openFullscreenView triggered');
                
                // Create fullscreen container
                const container = document.createElement('div');
                container.className = 'product-gallery__fullscreen';
                container.style.cssText = `
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0,0,0,0.9);
                    z-index: 9999;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                `;

                // Create close button
                const closeButton = document.createElement('button');
                closeButton.className = 'product-gallery__fullscreen-close';
                closeButton.innerHTML = '×'; // Using × symbol for the X
                closeButton.style.cssText = `
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    width: 30px;
                    height: 30px;
                    background: transparent;
                    border: none;
                    color: white;
                    font-size: 24px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0;
                    z-index: 10000;
                `;

                // Create image wrapper to handle click events separately
                const imageWrapper = document.createElement('div');
                imageWrapper.className = 'product-gallery__fullscreen-image-wrapper';
                imageWrapper.style.cssText = `
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    max-width: 90%;
                    max-height: 90%;
                `;

                // Create image element
                const img = document.createElement('img');
                img.src = imageUrl;
                img.className = 'product-gallery__fullscreen-image';
                img.style.cssText = `
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: contain;
                `;

                // Prevent immediate closure
                const preventImmediateClose = (e) => {
                    if (Date.now() - this.touchStartTime < 300) {
                        e.stopPropagation();
                    }
                };

                // Stop propagation of clicks on image and wrapper
                imageWrapper.addEventListener('click', (e) => {
                    e.stopPropagation();
                });

                // Add close functionality to container background and close button
                container.addEventListener('click', (e) => {
                    // Prevent the initial tap from triggering this event
                    if (Date.now() - this.touchStartTime < 300) {
                        return;
                    }
                    
                    // Only close if clicking the background (not the image or close button)
                    if (e.target === container) {
                        //console.log('Closing fullscreen view from background click');
                        container.remove();
                    }
                });

                closeButton.addEventListener('click', () => {
                    //console.log('Closing fullscreen view from close button');
                    container.remove();
                });

                // Assemble the elements
                imageWrapper.appendChild(img);
                container.appendChild(closeButton);
                container.appendChild(imageWrapper);
                document.body.appendChild(container);
                
                // Log after appending to verify creation
                /*console.log('Fullscreen view created:', {
                    container: container,
                    isInDOM: document.querySelector('.product-gallery__fullscreen') !== null,
                    imageUrl: imageUrl
                });*/
            }
            /* ======================================
            === End section: Touch Event Handlers ===
            ====================================== */
            
            /* ===================================
            === Start section: Utility Methods ===
            =================================== */
            // Helper method to format money consistently with Shopify's format
            formatMoney(cents) {
                const moneyFormat = (window.theme && window.theme.moneyFormat) || document.querySelector('[data-money-format]')?.getAttribute('data-money-format') || '${{amount}}';
                
                // Convert cents to pesos and ensure it's a number
                const pesos = parseFloat(cents) / 100;
                
                // Format with commas for thousands and 2 decimal places
                const formattedAmount = pesos.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                // Handle different Shopify money formats
                if (moneyFormat.includes('{{amount_no_decimals}}')) {
                    const amountNoDecimals = Math.round(pesos).toLocaleString('en-US');
                    return moneyFormat.replace('{{amount_no_decimals}}', amountNoDecimals);
                } else if (moneyFormat.includes('{{amount_with_comma_separator}}')) {
                    const amountComma = pesos.toLocaleString('de-DE', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    return moneyFormat.replace('{{amount_with_comma_separator}}', amountComma);
                }
                
                return moneyFormat.replace('{{amount}}', formattedAmount);
            }

            // Add helper method to get variant option by container type
            getVariantOptionByContainer(variant, containerClass) {
                // Maps variant options to their corresponding container elements
                // Returns the variant option value that matches the given container class
                const container = document.querySelector(`.${containerClass}`);
                if (!container) return null;

                const containerIndex = Array.from(container.parentElement.children)
                    .filter(el => el.classList.contains('variant-container'))
                    .indexOf(container);

                return variant.options[containerIndex];
            }

            // Add helper method to get selected option by container
            getSelectedOptionByContainer(containerClass) {
                const container = document.querySelector(`.${containerClass}`);
                if (!container) return null;

                const selectedInput = container.querySelector('input:checked');
                return selectedInput ? selectedInput.value : null;
            }

            // Add helper method to get container index
            getContainerIndex(containerClass) {
                const container = document.querySelector(`.${containerClass}`);
                if (!container) return -1;

                return Array.from(container.parentElement.children)
                    .filter(el => el.classList.contains('variant-container'))
                    .indexOf(container);
            }
            /* =================================
            === End section: Utility Methods ===
            ================================= */
        }

        // Initialize on DOMContentLoaded
        document.addEventListener('DOMContentLoaded', function() {
            //console.log('DOMContentLoaded - Creating ProductVariantHandler instance');
            window.productGallery = new ProductVariantHandler();
        });

    } catch (error) {
        console.error('Error in ProductGalleryHandler definition:', error);
    }
})();